import { call, put, takeLatest } from "redux-saga/effects";
import { ConfigurationsActionTypes } from "../actions/actionTypes";
import { configurationsAPI } from "../api/api";
import { configurationsStoreSelectors } from "../store/store";
import { ToasterService } from "../../../services/toaster/toaster.service";
import { API } from "../../../api/api";
import { checkObjectWithSchema, uuidv4, versionCompare } from "../../../utils/utils";

import _ from "lodash";

const parseCoin = coin =>
    typeof coin === "string" ? coin.split(",").map(c => Number(c)) : coin;

const parseGameGroups = (gameGroups, groupsIds) => {
    let gamesIds = [];
    gameGroups
        .filter(gg => groupsIds.includes(gg.id.toString()))
        .map(gg => {
            gamesIds = gamesIds.concat(gg.game_instances);
        });
    return gamesIds;
};

const GAME_TYPES = {
    0: "Bingo",
    1: "Spins",
    2: "Lotto",
    3: "Keno"
};

const prepareOutgoingConfig = (
    config,
    version,
    schema,
    gameConfigs,
    sounds,
    gameGroups,
    gameBundles,
    basic_game_settings,
    presets
) => {
    const settings = _.cloneDeep(config.settings.settings);
    let settingsWithoutTerminalKey = _.cloneDeep(settings);

    let { terminal_groups } = settingsWithoutTerminalKey;
    let game_groups = _.cloneDeep(gameGroups);

    delete settingsWithoutTerminalKey.terminal_groups;
    delete settingsWithoutTerminalKey.game_groups;

    const groupedByGame = _.groupBy(
        sounds.filter(sound => {
            return settings.settings.game_types.includes(
                GAME_TYPES[sound.game.type]
            );
        }),
        "identifier"
    );

    const mappedGroups = Object.keys(groupedByGame).map(identifier => {
        return {
            identifier: parseInt(identifier),
            groups: groupedByGame[identifier].map(group => {
                return {
                    id: group.id,
                    level: group.level,
                    sub_level: group.sub_level_enabled ? group.sub_level : null
                };
            })
        };
    });

    let usedGroups = [];
    if (config.settings.selectedGroupType === "terminal") {
        game_groups = [];
    } else if (config.settings.selectedGroupType === "game") {
        terminal_groups = [];
    }

    settings.progressives.map(pg => {
        if (pg.type === "reelstrike"){
            delete pg.preset;
        }
        if (config.settings.selectedGroupType === "terminal") {
            usedGroups = usedGroups.concat(pg.terminal_groups);

            if (
                pg.type === "levels" ||
                pg.type === "multipots" ||
                pg.type === "jumbolink" ||
                pg.type === "luckytokenslink" ||
                pg.type === "reelstrike" ||
                pg.type === "easylink" ||
                pg.type === "sap"
            ) {
                pg["children"].map(child => {
                    if (
                        child.hasOwnProperty("terminal_groups") &&
                        child.terminal_groups !== null &&
                        child.terminal_groups !== undefined
                    ) {
                        usedGroups = usedGroups.concat(child.terminal_groups);
                    }
                });
            }
        } else if (config.settings.selectedGroupType == "game") {
            usedGroups = usedGroups.concat(pg.game_groups);

            if (
                pg.type === "levels" ||
                pg.type === "multipots" ||
                pg.type === "jumbolink" ||
                pg.type === "luckytokenslink" ||
                pg.type === "reelstrike" ||
                pg.type === "easylink" ||
                pg.type === "sap"
            ) {
                pg["prizes"].map(prize => {
                    if (prize.proportion_type == "normal" && prize.hasOwnProperty("max_proportional_total_bet")){
                        delete prize["max_proportional_total_bet"]
                    }
                })
                pg["children"].map(child => {
                    if (
                        child.hasOwnProperty("game_groups") &&
                        child.game_groups !== null &&
                        child.game_groups !== undefined
                    ) {
                        usedGroups = usedGroups.concat(child.game_groups);
                    }
                    child["prizes"].map(prize => {
                        if (prize.proportion_type == "normal" && prize.hasOwnProperty("max_proportional_total_bet")){
                            delete prize["max_proportional_total_bet"]
                        }
                    })
                });
            }
        }
    });

    settings.special_prizes.map(pg => {
        if (config.settings.selectedGroupType == "terminal") {
            usedGroups = usedGroups.concat(pg.terminal_groups);
        } else if (config.settings.selectedGroupType == "game") {
            usedGroups = usedGroups.concat(pg.game_groups);
        }
    });

    usedGroups = _.uniq(usedGroups);

    if (config.settings.selectedGroupType == "terminal") {
        terminal_groups = terminal_groups.filter(tg => {
            if (tg.description === "") {
                tg.description = null;
            }
            return usedGroups.includes(tg.id);
        });
    } else if (config.settings.selectedGroupType == "game") {
        game_groups = game_groups.filter(tg => {
            return usedGroups.includes(tg.id);
        });
    }

    let minValueProgHandpay =
        settings.settings.minimum_value_progressive_handpay;
    if (settings.settings.points_system && !("point_system" in settings.settings)) {
        //let biggestMaxValue = 0;
        if (settings.progressives.length > 0) {
            minValueProgHandpay = 4294967290;
        } else {
            minValueProgHandpay = 0;
        }
    } else {
        minValueProgHandpay = parseInt(String(minValueProgHandpay * 100));
    }

    let emailSettings = { ...settings.email };
    if (
        emailSettings &&
        emailSettings.hasOwnProperty("mail") &&
        emailSettings.mail.hasOwnProperty("password")
    ) {
        if (
            emailSettings.mail.password != null &&
            emailSettings.mail != undefined &&
            emailSettings.mail != ""
        ) {
            emailSettings.mail.password = btoa(emailSettings.mail.password);
        }

        if (
            emailSettings.mail != undefined &&
            emailSettings.mail != "" &&
            emailSettings.mail.timeout != null &&
            emailSettings.mail.timeout != ""
        ) {
            emailSettings.mail.timeout = emailSettings.mail.timeout * 1000;
        }
    }

    const shouldHaveSpecialPrizes = settings.settings.game_types.includes(
        GAME_TYPES[0]
    );

    let subsidiaryId = configurationsStoreSelectors.editingConfiguration()
                            .subsidiary.id

    gameBundles.map(gb => {
        if(gb.alias && gb.alias.length>0){
            let show_alias = gb.alias.find(a=>a.subsidiary==subsidiaryId)
            gb.name = show_alias && show_alias.value && show_alias ? show_alias.value : gb.name
        }
    })
    let new_settings = {
            ...settingsWithoutTerminalKey,
            email: emailSettings || {},
            settings: schema.components.settings
                ? {
                      ...checkObjectWithSchema(
                          { ...settings.settings },
                          schema.components.settings.schema
                      ),
                      minimum_value_progressive_handpay: minValueProgHandpay
                  }
                : {},
            accounting: schema.components.accounting
                ? {
                      ...checkObjectWithSchema(
                          {
                              ...settings.accounting
                          },
                          schema.components.accounting.schema
                      )
                  }
                : {},
            progressives: settings.progressives.map(progressive => {
                if (progressive.preset !== undefined){
                     if (progressive.preset === 0){
                         progressive.preset_name = "Not Applicable";
                    }
                    let selected_preset = presets.filter(p=>p.id == progressive.preset);
                    if (selected_preset.length>0){
                        progressive.preset_name = selected_preset[0].name;
                    }
                }

                if (
                    progressive.type == "normal" ||
                    progressive.type == "proportional" ||
                    progressive.type == "fractionated"
                ) {
                    let progressiveSchema =
                        schema.components.progressives.schema.definitions
                            .$proportional_jackpot;
                    if (progressive.type == "normal") {
                        progressiveSchema =
                            progressive.type == "normal"
                                ? schema.components.progressives.schema
                                      .definitions.$normal_jackpot
                                : progressiveSchema;
                    } else if (progressive.type == "fractionated") {
                        progressiveSchema =
                            progressive.type == "fractionated"
                                ? schema.components.progressives.schema
                                      .definitions.$fractionated_jackpot
                                : progressiveSchema;
                    }

                    if (progressiveSchema.properties.extension_settings) {
                        progressive.extension_settings = progressiveSchema.properties.extension_settings.default;
                    }

                    const processedProgressive = {
                        ...checkObjectWithSchema(
                            {
                                ...progressive
                            },
                            progressiveSchema
                        ),
                        coin: parseCoin(progressive.coin),
                        game_groups: parseGameGroups(
                            game_groups,
                            progressive.game_groups
                        )
                    };

                    return processedProgressive;
                }
                else
                {
                    const schemaKey =
                        progressive.type == "levels" ? "$levels"
                            : progressive.type == "multipots" ? "$multipots"
                                : progressive.type == "jumbolink" ? "$jumbolink"
                                    : progressive.type == "luckytokenslink" ? "$luckytokenslink"
                                        : "$progressive";
                    if (progressive.type == "reeltrike" && progressive.preset == ""){
                        progressive.preset = null;
                    }
                    return {
                        ...checkObjectWithSchema(
                            { ...progressive },
                            schema.components.progressives.schema.definitions[
                                schemaKey
                            ]
                        ),
                        prizes: progressive.prizes.map(prize => {
                            //esta key só pode ser enviada nos sitios corretos
                            delete prize.extension_settings;
                            if(schema.components.progressives.schema
                                    .definitions[schemaKey].properties
                                    .prizes.items.properties.extension_settings){
                                prize.extension_settings = schema.components.progressives.schema
                                    .definitions[schemaKey].properties
                                    .prizes.items.properties.extension_settings.default;
                            }

                            return {
                                ...checkObjectWithSchema(
                                    { ...prize, max_bet: 0.01, min_bet: 0.01 },
                                    schema.components.progressives.schema
                                        .definitions[schemaKey].properties
                                        .prizes
                                )
                            };
                        }),
                        children: progressive.children.map(child => {
                            if (child.preset !== undefined){
                                 if (child.preset === 0){
                                     child.preset_name = "Not Applicable";
                                }
                                let selected_preset_children = presets.filter(p=>p.id == child.preset);
                                if (selected_preset_children.length>0){
                                    child.preset_name = selected_preset_children[0].name;
                                }
                            }

                            return {
                                ...checkObjectWithSchema(
                                    child,
                                    schema.components.progressives.schema
                                        .definitions[schemaKey].properties
                                        .children
                                ),
                                game_groups: parseGameGroups(
                                    game_groups,
                                    child.game_groups
                                ),
                                type: progressive.type,
                                prizes: child.preset === 0 ? [] // s n tem preset n envia prizes
                                    : child.prizes.map(prize => {
                                    //esta key só pode ser enviada nos sitios corretos
                                    delete prize.extension_settings;
                                    return {
                                        ...checkObjectWithSchema(
                                            {
                                                ...prize,
                                                max_bet: 0.01,
                                                min_bet: 0.01
                                            },
                                            schema.components.progressives
                                                .schema.definitions[schemaKey]
                                                .properties.prizes
                                        )
                                    };
                                })
                            };
                        }),
                        coin: parseCoin(progressive.coin),
                        game_groups: null,
                        terminal_groups: null
                    };
                }
            }),
            jackpot_groups: {
                use_game_groups: config.settings.selectedGroupType === "game",
                use_terminal_groups:
                    config.settings.selectedGroupType === "terminal",
                terminal_groups:
                    config.settings.selectedGroupType !== "game"
                        ? terminal_groups || []
                        : [],
                game_groups:
                    config.settings.selectedGroupType === "game"
                        ? game_groups || []
                        : []
            },
            special_prizes: shouldHaveSpecialPrizes
                 ? settings.special_prizes.map(prize => {
                    if (prize.preset !== undefined){
                         if (prize.preset === 0){
                             prize.preset_name = "Not Applicable";
                        }
                        let selected_preset = presets.filter(p=>p.id == prize.preset);
                        if (selected_preset.length>0){
                            prize.preset_name = selected_preset[0].name;
                        }
                    }
                    return {
                        ...checkObjectWithSchema(
                            {
                                ...prize
                            },
                            schema.components.special_prizes.schema,
                            prize.type == "pig_boom"
                                ? schema.components.special_prizes.schema
                                    .definitions.$pig_boom
                                : schema.components.special_prizes.schema
                                    .definitions.$mr_champion
                            ),
                        coin: parseCoin(prize.coin),
                        game_groups: parseGameGroups(
                            game_groups,
                            prize.game_groups
                        )
                    }
                })
                : [],
            global_jackpot: schema.components.global_jackpot
                ? {
                      ...checkObjectWithSchema(
                          { ...settings.global_jackpot },
                          schema.components.global_jackpot.schema
                      ),
                      coin: parseCoin(settings.global_jackpot.coin)
                  }
                : {},
            game_settings: gameConfigs,
            game_bundles: gameBundles,
            basic_game_settings: basic_game_settings,
            sounds: mappedGroups
        };
    // Se por algum motivo n existir spins (aconteceu num bug que n consegui replicar)
    if (!("spins" in new_settings.settings) || new_settings.settings["spins"] == null) {
        new_settings.settings["spins"] = null;
    }else{
        new_settings.settings["spins"] = checkObjectWithSchema(
                {...settings.settings.spins},
                schema.components.settings.schema.definitions.$spins
            )
    }
    if (!("bingo" in new_settings.settings) || new_settings.settings["bingo"] == null) {
        new_settings.settings["bingo"] = null;
    }else{
        new_settings.settings["bingo"] = checkObjectWithSchema(
                {...settings.settings.bingo},
                schema.components.settings.schema.definitions.$bingo
            )
    }
    if (!("lotto" in new_settings.settings) || new_settings.settings["lotto"] == null) {
        new_settings.settings["lotto"] = null;
    }else{
        new_settings.settings["lotto"] = checkObjectWithSchema(
                {...settings.settings.lotto},
                schema.components.settings.schema.definitions.$lotto
            )
    }
    if (!("keno" in new_settings.settings) || new_settings.settings["keno"] == null) {
        new_settings.settings["keno"] = null;
    }

    if (!("point_system" in new_settings.settings)) {
        // valores default obrigatórios para versões anteriores a 2.0.0
        new_settings.settings["spins"]={
            enable_pig_boom: false,
            enable_mr_champion: false
        }
    }
    return {
        settings: new_settings,
        schema: version
    };
};

function* createConfiguration(_action) {
    try {
        let gameConfgs = [];

        try {
            let gameConfgsResult = yield call(() =>
                configurationsAPI.loadGameConfigurations({
                    subsidiary:
                        configurationsStoreSelectors.editingConfiguration()
                            .subsidiary.id
                })
            );

            let progressiveRules = configurationsStoreSelectors.progressiveRules();
            let presets=[]
            Object.keys(progressiveRules).map(rule=>{
                if(progressiveRules[rule].presets) presets.push(...progressiveRules[rule].presets)
            })

            gameConfgs = configurationsStoreSelectors
                .gameInstances()
                .results.map(instance => {
                    return {
                        id: instance.identifier,
                        config_id: gameConfgsResult.data[instance.id].id,
                        name: gameConfgsResult.data[instance.id].label,
                        software_house: instance.game.software_house['name'],
                        type: instance.game.type,
                        version: "1",
                        configuration:
                            gameConfgsResult.data[instance.id].configuration,
                        trademark: instance.game.trademark ? {
                                id: instance.game.trademark.trademark_id,
                                name: instance.game.trademark.name
                            } : null,
                        series:  instance.game.series ? {
                                id: instance.game.series.series_id,
                                name: instance.game.series.name
                            } : null,
                        feature: instance.game.feature ? {
                                id: instance.game.feature.feature_id,
                                name: instance.game.feature.name
                            } : null,
                        platform: instance.game.platform ? {
                                id: instance.game.platform.platform_id,
                                name: instance.game.platform.name
                            } : null,
                        game_type: instance.game.game_type ? {
                                id: instance.game.game_type.type_id,
                                name: instance.game.game_type.name
                            } : null
                    };
                });

            const gameBundles = yield call(() =>
                configurationsAPI.getGameBundles({
                    skip: 0,
                    top: 10000
                })
            );

            let bundles = gameBundles.data.results.filter(bundle =>
                bundle.subsidiaries.includes(
                    configurationsStoreSelectors.editingConfiguration()
                        .subsidiary.id
                )
            );

            if (gameConfgs.length > 0) {
                bundles.map(bundle => {
                    bundle.games = bundle.games.filter(
                        game =>
                            gameConfgs.findIndex(item => item.id == game.id) >
                            -1
                    );
                    return bundle;
                });
            }

            bundles = bundles.filter(bundle => bundle.games.length > 0);

            let basicGame = yield call(() => configurationsAPI.getBasicGames());
            basicGame.data.results.map(game => {
                delete game.image;
                delete game.software_house;
            });

            const versionComparison = versionCompare(
                configurationsStoreSelectors.editingConfiguration()[
                    "system_server_version"
                ],
                "1.6.0"
            );
            if (versionComparison == -1) {
                const base = basicGame.data.results.find(
                    game => game.id == 500
                );
                if (base != undefined) {
                    basicGame.data.results = base;
                } else {
                    basicGame.data.results = basicGame.data.results[0];
                }
            }

            const configSP =
                configurationsStoreSelectors.editingConfiguration().settings;
            if (configSP.settings.settings.game_types.includes("Spins") && configSP.settings.settings.game_types.includes("Bingo")) {
                const bingoHasPigBoom =
                    configSP.settings.settings.bingo &&
                    configSP.settings.settings.bingo.enable_pig_boom == true;
                const bingoHasMrChampion =
                    configSP.settings.settings.bingo &&
                    configSP.settings.settings.bingo.enable_mr_champion == true;

                const spinsHasPigBoom =
                    configSP.settings.settings.spins &&
                    configSP.settings.settings.spins.enable_pig_boom == true;
                const spinsHasMrChampion =
                    configSP.settings.settings.spins &&
                    configSP.settings.settings.spins.enable_mr_champion == true;

                const gameInstances =
                    configurationsStoreSelectors.gameInstances().results;

                if (
                    (!bingoHasPigBoom || !spinsHasPigBoom) &&
                    (bingoHasPigBoom || spinsHasPigBoom)
                ) {
                    const spPigBoom = configSP.settings.special_prizes.filter(
                        prize => {
                            return prize.type == "pig_boom";
                        }
                    );

                    const typeDisabled = bingoHasPigBoom ? "Spins" : "Bingo";
                    const reducedGroups = _.reduce(
                        spPigBoom,
                        (groups, prize, key) => {
                            return groups.concat(prize.game_groups);
                        },
                        []
                    );

                    reducedGroups.map(group => {
                        const gameGroup = _.find(
                            configSP.settings.game_groups,
                            gp => {
                                return gp.id == group;
                            }
                        );

                        gameGroup.game_instances.map(instance => {
                            const game_instance = _.find(gameInstances, gi => {
                                return instance == gi.identifier;
                            });

                            if (
                                GAME_TYPES[game_instance.game.type] ==
                                typeDisabled
                            ) {
                                throw {
                                    text: `A Special Prize of type Pig Boom has a game group assigned with games of type ${typeDisabled}, but this is disabled in Settings. Please validate and try again.`
                                };
                            }
                        });
                    });
                }

                if (
                    (!bingoHasMrChampion || !spinsHasMrChampion) &&
                    (bingoHasMrChampion || spinsHasMrChampion)
                ) {
                    const spMrChampion =
                        configSP.settings.special_prizes.filter(prize => {
                            return prize.type == "mr_champion";
                        });

                    const typeDisabled = bingoHasMrChampion ? "Spins" : "Bingo";
                    const reducedGroups = _.reduce(
                        spMrChampion,
                        (groups, prize, key) => {
                            return groups.concat(prize.game_groups);
                        },
                        []
                    );

                    reducedGroups.map(group => {
                        const gameGroup = _.find(
                            configSP.settings.game_groups,
                            gp => {
                                return gp.id == group;
                            }
                        );

                        gameGroup.game_instances.map(instance => {
                            const game_instance = _.find(gameInstances, gi => {
                                return instance == gi.identifier;
                            });

                            if (
                                GAME_TYPES[game_instance.game.type] ==
                                typeDisabled
                            ) {
                                throw {
                                    text: `A Special Prize of type Mr Champion has a game group assigned with games of type ${typeDisabled}, but this is disabled in Settings. Please validate and try again.`
                                };
                            }
                        });
                    });
                }
            }

            const config = prepareOutgoingConfig(
                configurationsStoreSelectors.editingConfiguration(),
                configurationsStoreSelectors.schema().version,
                configurationsStoreSelectors.schema(),
                gameConfgs,
                configurationsStoreSelectors.sounds(),
                configurationsStoreSelectors.gameGroups(),
                bundles,
                basicGame.data.results,
                presets
            );

            const response = yield call(() =>
                configurationsAPI.createConfiguration({
                    serverId: _action.payload.serverId,
                    config
                })
            );

            ToasterService.successToast("Configuration successfully created");

            yield put({
                type: ConfigurationsActionTypes.CREATE_CONFIGURATION_SUCCESS,
                payload: response.data
            });
        } catch (e) {
            API.handleError(e.response, "Error fetching game configurations.");

            yield put({
                type: ConfigurationsActionTypes.CREATE_CONFIGURATION_FAIL,
                payload: e
            });
        }
    } catch (e) {
        API.handleError(e.response, "Error creating configuration.");

        yield put({
            type: ConfigurationsActionTypes.CREATE_CONFIGURATION_FAIL,
            payload: e
        });
    }
}

function* editConfiguration(action) {
    try {
        let gameConfgs = [];

        try {
            let gameConfgsResult = yield call(() =>
                configurationsAPI.loadGameConfigurations({
                    subsidiary:
                        configurationsStoreSelectors.editingConfiguration()
                            .subsidiary.id
                })
            );

            let progressiveRules = configurationsStoreSelectors.progressiveRules();
            let presets=[]
            Object.keys(progressiveRules).map(rule=>{
                if(progressiveRules[rule].presets) presets.push(...progressiveRules[rule].presets)
            })

            gameConfgs = configurationsStoreSelectors
                .gameInstances()
                .results.map(instance => {
                    return {
                        id: instance.identifier,
                        config_id: gameConfgsResult.data[instance.id].id,
                        name: gameConfgsResult.data[instance.id].label,
                        software_house: instance.game.software_house['name'],
                        type: instance.game.type,
                        version: "1",
                        configuration:
                            gameConfgsResult.data[instance.id].configuration,
                        trademark: instance.game.trademark ? {
                                id: instance.game.trademark.trademark_id,
                                name: instance.game.trademark.name
                            } : null,
                        series:  instance.game.series ? {
                                id: instance.game.series.series_id,
                                name: instance.game.series.name
                            } : null,
                        feature: instance.game.feature ? {
                                id: instance.game.feature.feature_id,
                                name: instance.game.feature.name
                            } : null,
                        platform: instance.game.platform ? {
                                id: instance.game.platform.platform_id,
                                name: instance.game.platform.name
                            } : null,
                        game_type: instance.game.game_type ? {
                            id: instance.game.game_type.type_id,
                            name: instance.game.game_type.name
                        } : null
                    };
                });

            const gameBundles = yield call(() =>
                configurationsAPI.getGameBundles({
                    skip: 0,
                    top: 10000
                })
            );

            let bundles = gameBundles.data.results.filter(bundle =>
                bundle.subsidiaries.includes(
                    configurationsStoreSelectors.editingConfiguration()
                        .subsidiary.id
                )
            );

            if (gameConfgs.length > 0) {
                bundles.map(bundle => {
                    bundle.games = bundle.games.filter(
                        game =>
                            gameConfgs.findIndex(item => item.id == game.id) >
                            -1
                    );
                    return bundle;
                });
            }

            bundles = bundles.filter(bundle => bundle.games.length > 0);

            let basicGame = yield call(() => configurationsAPI.getBasicGames());
            basicGame.data.results.map(game => {
                delete game.image;
                delete game.software_house;
            });

            const versionComparison = versionCompare(
                configurationsStoreSelectors.editingConfiguration()[
                    "system_server_version"
                ],
                "1.6.0"
            );
            if (versionComparison == -1) {
                const base = basicGame.data.results.find(
                    game => game.id == 500
                );
                if (base != undefined) {
                    basicGame.data.results = base;
                } else {
                    basicGame.data.results = basicGame.data.results[0];
                }
            }

            const configSP =
                configurationsStoreSelectors.editingConfiguration().settings;

            if (configSP.settings.settings.game_types.includes("Spins") && configSP.settings.settings.game_types.includes("Bingo")) {
                const bingoHasPigBoom =
                    configSP.settings.settings.bingo &&
                    configSP.settings.settings.bingo.enable_pig_boom == true;
                const bingoHasMrChampion =
                    configSP.settings.settings.bingo &&
                    configSP.settings.settings.bingo.enable_mr_champion == true;

                const spinsHasPigBoom =
                    configSP.settings.settings.spins &&
                    configSP.settings.settings.spins.enable_pig_boom == true;
                const spinsHasMrChampion =
                    configSP.settings.settings.spins &&
                    configSP.settings.settings.spins.enable_mr_champion == true;

                const gameInstances =
                    configurationsStoreSelectors.gameInstances().results;

                if (
                    (!bingoHasPigBoom || !spinsHasPigBoom) &&
                    (bingoHasPigBoom || spinsHasPigBoom)
                ) {
                    const spPigBoom = configSP.settings.special_prizes.filter(
                        prize => {
                            return prize.type == "pig_boom";
                        }
                    );

                    const typeDisabled = bingoHasPigBoom ? "Spins" : "Bingo";
                    const reducedGroups = _.reduce(
                        spPigBoom,
                        (groups, prize, key) => {
                            return groups.concat(prize.game_groups);
                        },
                        []
                    );

                    reducedGroups.map(group => {
                        const gameGroup = _.find(
                            configurationsStoreSelectors.gameGroups(),
                            gp => {
                                return gp.id == group;
                            }
                        );

                        gameGroup.game_instances.map(instance => {
                            const game_instance = _.find(gameInstances, gi => {
                                return instance == gi.identifier;
                            });

                            if (
                                GAME_TYPES[game_instance.game.type] ==
                                typeDisabled
                            ) {
                                throw {
                                    text: `A Special Prize of type Pig Boom has a game group assigned with games of type ${typeDisabled}, but this is disabled in Settings. Please validate and try again.`
                                };
                            }
                        });
                    });
                }

                if (
                    (!bingoHasMrChampion || !spinsHasMrChampion) &&
                    (bingoHasMrChampion || spinsHasMrChampion)
                ) {
                    const spMrChampion =
                        configSP.settings.special_prizes.filter(prize => {
                            return prize.type == "mr_champion";
                        });

                    const typeDisabled = bingoHasMrChampion ? "Spins" : "Bingo";
                    const reducedGroups = _.reduce(
                        spMrChampion,
                        (groups, prize, key) => {
                            return groups.concat(prize.game_groups);
                        },
                        []
                    );

                    reducedGroups.map(group => {
                        const gameGroup = _.find(
                            configSP.settings.game_groups,
                            gp => {
                                return gp.id == group;
                            }
                        );

                        gameGroup.game_instances.map(instance => {
                            const game_instance = _.find(gameInstances, gi => {
                                return instance == gi.identifier;
                            });

                            if (
                                GAME_TYPES[game_instance.game.type] ==
                                typeDisabled
                            ) {
                                throw {
                                    text: `A Special Prize of type Mr Champion has a game group assigned with games of type ${typeDisabled}, but this is disabled in Settings. Please validate and try again.`
                                };
                            }
                        });
                    });
                }
            }

            const config = prepareOutgoingConfig(
                configurationsStoreSelectors.editingConfiguration(),
                configurationsStoreSelectors.schema().version,
                configurationsStoreSelectors.schema(),
                gameConfgs,
                configurationsStoreSelectors.sounds(),
                configurationsStoreSelectors.gameGroups(),
                bundles,
                basicGame.data.results,
                presets
            );

            const response = yield call(() =>
                configurationsAPI.editConfiguration({
                    config,
                    serverId: action.payload.serverId
                })
            );

            ToasterService.successToast("Configuration successfully created");

            yield put({
                type: ConfigurationsActionTypes.EDIT_CONFIGURATION_SUCCESS,
                payload: response.data
            });
        } catch (e) {
            API.handleError(e.response, "Error fetching game configurations.");

            yield put({
                type: ConfigurationsActionTypes.EDIT_CONFIGURATION_FAIL,
                payload: e
            });
        }
        //}
    } catch (e) {
        API.handleError(e.response, "Error creating configuration.");

        yield put({
            type: ConfigurationsActionTypes.EDIT_CONFIGURATION_FAIL,
            payload: e
        });
    }
}

export function* createConfigurationWatcher() {
    yield takeLatest(
        ConfigurationsActionTypes.CREATE_CONFIGURATION,
        createConfiguration
    );
}

export function* editConfigurationWatcher() {
    yield takeLatest(
        ConfigurationsActionTypes.EDIT_CONFIGURATION,
        editConfiguration
    );
}
